export function hexToRgba({ hex, alpha = 1, darken = 0 }: { hex: string; alpha?: number; darken?: number }) {
  hex = hex.replace(/^#/, '')

  let r: number = parseInt(hex.substring(0, 2), 16)
  let g: number = parseInt(hex.substring(2, 4), 16)
  let b: number = parseInt(hex.substring(4, 6), 16)

  r = Math.floor(r * (1 - darken))
  g = Math.floor(g * (1 - darken))
  b = Math.floor(b * (1 - darken))

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export function hexToRgb(hex: string) {
  hex = hex.replace(/^#/, '')

  const r: number = parseInt(hex.substring(0, 2), 16)
  const g: number = parseInt(hex.substring(2, 4), 16)
  const b: number = parseInt(hex.substring(4, 6), 16)

  return `rgb(${r}, ${g}, ${b})`
}
